import { useState } from 'react';
import { quotesAPI } from '../../services/api';
import toast from 'react-hot-toast';

export default function StatusModal({ quote, onClose, onSaved }) {
  const [status,       setStatus]      = useState(quote.status);
  const [close_reason, setReason]      = useState(quote.close_reason || '');
  const [close_date,   setCloseDate]   = useState(
    quote.close_date ? quote.close_date.split('T')[0] : new Date().toISOString().split('T')[0]
  );
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await quotesAPI.updateStatus(quote.id, {
        status,
        close_reason: close_reason || undefined,
        close_date:   ['closed_won','closed_lost'].includes(status) ? close_date : undefined,
      });
      toast.success('Status updated');
      onSaved();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <span className="modal-title">Update Quote Status</span>
          <button className="btn btn-ghost btn-icon" onClick={onClose}>✕</button>
        </div>

        <div className="form-group">
          <label className="form-label">Status</label>
          <select className="form-select" value={status} onChange={e => setStatus(e.target.value)}>
            <option value="draft">Draft</option>
            <option value="open">Open</option>
            <option value="closed_won">Closed — Won ✅</option>
            <option value="closed_lost">Closed — Lost ❌</option>
          </select>
        </div>

        {['closed_won','closed_lost'].includes(status) && (
          <>
            <div className="form-group">
              <label className="form-label">Close Date</label>
              <input className="form-input" type="date" value={close_date}
                onChange={e => setCloseDate(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Reason / Notes</label>
              <input className="form-input" placeholder="e.g. Client went with competitor"
                value={close_reason} onChange={e => setReason(e.target.value)} />
            </div>
          </>
        )}

        <div className="flex justify-between" style={{ marginTop: 20 }}>
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving…' : 'Update Status'}
          </button>
        </div>
      </div>
    </div>
  );
}
